import { render, staticRenderFns } from "./AbkBasicInfoForm.vue?vue&type=template&id=0f0238dc&scoped=true&"
import script from "./AbkBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./AbkBasicInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkBasicInfoForm.vue?vue&type=style&index=0&id=0f0238dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0238dc",
  null
  
)

export default component.exports